"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _store = require('shared/store'); var _store2 = _interopRequireDefault(_store);
var _selectBlobjectByWrappedKey = require('shared/selectors/blobject/common/selectBlobjectByWrappedKey');


/* How long to wait for a chat read from the server to reach the store. */
const ARRIVAL_MS = 8000

/* Opens a chat known only by its conversation key (a sent form's ChatKey).
 * A chat not in the store yet is asked for; GetBlobjectByWrappedKey answers
 * empty and the chat arrives in a later socket update, so this waits for it. */
 const openFormChat = async (chatKey) => {
  // SAFETY: a sent form's ChatKey is the chat's conversation (wrapped) key.
  const key = chatKey 
  const find = () => _selectBlobjectByWrappedKey.selectBlobjectByWrappedKey.call(void 0, _store.getState.call(void 0, ), key)
  let blobject = find()
  if (!blobject) {
    const arrived = new Promise(resolve => {
      const stop = _store2.default.call(void 0, ).subscribe(() => { if (find()) { stop(); resolve() } })
      setTimeout(() => { stop(); resolve() }, ARRIVAL_MS)
    })
    await _actions2.default.getBlobjectByWrappedKey({ WrappedKey: key }).catch(() => null)
    if (!find()) await arrived
    blobject = find()
  }
  if (blobject) _actions2.default.gotoBlobject(blobject.WrappedType, blobject.WrappedKey, blobject.Key)
}; exports.openFormChat = openFormChat
